module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand4-55bb949dac9d14c87e31f3f0c7076e2e.jpg";